const template = `
	<div class="line-chart">
		<div class="chart-inner">
			<highcharts
				:key="renderKey"
				v-if="series"
				:options="opts"
			></highcharts>
			<div v-else class="loading-label">{{ ii('LOADING') }}...</div>
		</div>
	</div>
`;

export default {
	template,
	props: ['title', 'series', 'legend'],
	data() {
		return {
			renderKey: 0
		};
	},
	computed: {
		seriesLen() {
			return this.series && this.series.length;
		},
		opts() {
			let legend = {};
			if (this.legend === 'vertical' || !this.legend && this.seriesLen >= 10) {
				legend = {
					layout: 'vertical',
					align: 'right',
					width: 100
				}
			} else {
				legend = {
					maxHeight: 80
				}
			}
			let opts = {
				title: {
					text: this.title,
					style: {
						textTransform: 'uppercase',
						fontSize: 15,
						fontWeight: 500
					}
				},
				credits: {
					enabled: false
				},
				chart: {
					marginTop: 75,
					marginBottom: 70,
					spacingTop: 30,
					spacingBottom: 5,
					height: 300,
					animation: false,
					style: {
						fontFamily: 'Roboto, "Open Sans", sanf-serif, helvetica, tahoma, verdana'
					}
				},
				rangeSelector: {
					enabled: false
				},
				colors: ['#2f7ed8', '#0d233a', '#f28f43', '#8bbc21', '#1aadce', '#492970', '#910000', '#77a1e5', '#c42525', '#a6c96a'],
				tooltip: {
					xDateFormat: '%b %e, %A',
					shared: true,
					hideDelay: 100
				},
				yAxis: {
					title: {
						text: ''
					},
					labels: {},
					min: 0
				},
				legend,
				xAxis: {
					crosshair: {
						width: 1,
						color: '#ddd'
					},
					type: 'datetime',
					dateTimeLabelFormats: {
						day: '%b %e',
						week: '%b %e'
					}
				},
				series: this.series
			};
			return opts;
		}
	},
	watch: {
		seriesLen() {
			this.renderKey++;
		}
	}
}